class ProductForm extends HTMLElement {
  constructor () {
    super()

    this.form = this.querySelector('form')
    this.productOptions = this.form.querySelectorAll('.product-options [name*="option"]')
    this.atcBtn = this.form.querySelector('.btn-atc')
    this.buyBtn = this.form.querySelector('.btn-buy')

    this.variants = JSON.parse(this.form.dataset.variants || '[]')

    this.form.addEventListener('submit', e => this.onSubmit(e))

    this.productOptions.forEach(el =>
      el.addEventListener('change', e => this.onChangeProductOption(e))
    )

    this.buyBtn?.addEventListener('click', e => this.onClickBuyBtn(e))

    const fabricTypeSelect = this.form.querySelector('[name="option-fabric"]')

    if (fabricTypeSelect) {
      this.updateFabricColorOptions(
        this.getFabricKey(fabricTypeSelect.value)
      )

      fabricTypeSelect.addEventListener('change', () => {
        this.updateFabricColorOptions(
          this.getFabricKey(fabricTypeSelect.value)
        )
      })
    }

    setTimeout(() => {
      this.initFabricSwatches()
      this.initCanopySwatches()

      //const colorSelect = this.form.querySelector('[name*="color"]')
      const colorSelect = this.form.querySelector(
        '[name="option-color"], [name="option-headboard-fabric-color"]'
      )

      if (colorSelect) {

        const firstOptionValue = colorSelect.options[0].value;
        //this.highlightSwatch(colorSelect.value) if we want to use the value shopify actually selects

        this.highlightSwatch(firstOptionValue)

        this.form.querySelectorAll('.canopy-swatch').forEach(btn => {
          btn.classList.toggle(
            'active',
            btn.dataset.value === 'Bone Linen'
          )
        })

      }
    }, 0)
  }

  /* -----------------------------
   * VARIANT LOOKUP
   * ----------------------------- */

  getSelectedVariant () {
    const selected = []

    this.productOptions.forEach(el => {
      if (el.type === 'radio' && el.checked) {
        selected.push(el.value)
      }

      if (el.tagName === 'SELECT') {
        selected.push(el.value)
      }
    })

    return this.variants.find(v =>
      v.options.every((opt, i) => opt === selected[i])
    )
  }

  /* -----------------------------
   * OPTION CHANGE
   * ----------------------------- */

  onChangeProductOption () {
    const fabricTypeSelect = this.form.querySelector('[name="option-fabric"]')

    if (fabricTypeSelect) {
      this.updateFabricColorOptions(
        this.getFabricKey(fabricTypeSelect.value)
      )
    }

    const variant = this.getSelectedVariant()
    console.log(variant);

    if (!variant) return

    const variantInput = this.form.querySelector('[name="id"]')

    if (variantInput) {
      variantInput.value = variant.id
    }

    window.dispatchEvent(
      new CustomEvent('kt.product.variant.change', {
        detail: variant
      })
    )

    this.adjustPricing(variant)
    this.adjustButtons(variant)
    this.updateFabricGalleryImage(variant)
  }

  /* -----------------------------
   * FABRIC FILTERING
   * ----------------------------- */

  updateFabricColorOptions (selectedFabric) {
    const select = this.form.querySelector('[name*="color"]')

    if (!select) return

    const valid = new Set()

    this.variants.forEach(v => {
      const color = v.options[v.options.length - 1]

      if (color && color.includes(selectedFabric)) {
        valid.add(color)
      }
    })

    Array.from(select.options).forEach(option => {
      const isValid = valid.has(option.value)

      option.hidden = !isValid
      option.disabled = !isValid
    })

    // Show / hide swatches
    const swatches = this.form.querySelectorAll('.fabric-swatch')

    swatches.forEach(btn => {
      btn.style.display = valid.has(btn.dataset.value)
        ? ''
        : 'none'
    })

    // Auto-select first valid color
    if (!valid.has(select.value)) {
      const firstValid = [...valid][0]

      if (firstValid) {
        select.value = firstValid
      }
    }

    this.highlightSwatch(select.value)
  }

  /* -----------------------------
   * SWATCHES
   * ----------------------------- */

  initFabricSwatches () {
    const select = this.form.querySelector('[name*="color"]')

    if (!select) return

    const swatches = this.form.querySelectorAll('.fabric-swatch')

    swatches.forEach(btn => {
      btn.addEventListener('click', () => {
        const value = btn.dataset.value

        select.value = value

        this.highlightSwatch(value)

        select.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        )
      })
    })
  }

  highlightSwatch (value) {
    this.form.querySelectorAll('.fabric-swatch').forEach(btn => {
      btn.classList.toggle(
        'active',
        btn.dataset.value === value
      )
    })
  }

  /* -----------------------------
   * CANOPY SWATCHES (FIXED)
   * ----------------------------- */

  initCanopySwatches () {
    const canopySelect = document.querySelector('#CanopyFabric')
    const canopyContainer = document.querySelector('#CanopySwatches')

    if (!canopySelect || !canopyContainer) return

    canopyContainer.innerHTML = ''

    Array.from(canopySelect.options).forEach(option => {

      const matchingVariants = this.variants.filter(v =>
        v.options.includes(option.value)
      )

      const variantWithImage = matchingVariants.find(v =>
        v.featured_image?.src || v.image?.src
      )

      const imageUrl =
        variantWithImage?.featured_image?.src ||
        variantWithImage?.image?.src ||
        null

      const btn = document.createElement('button')

      btn.type = 'button'
      btn.className = 'fabric-swatch canopy-swatch'
      btn.dataset.value = option.value

      btn.innerHTML = `
        ${imageUrl ? `<img src="${imageUrl}" alt="${option.value}">` : ''}
        <span>${option.value}</span>
      `

      btn.addEventListener('click', () => {
        canopySelect.value = option.value

        canopyContainer
          .querySelectorAll('.canopy-swatch')
          .forEach(el => el.classList.remove('active'))

        btn.classList.add('active')
      })

      canopyContainer.appendChild(btn)
    })

    // ✅ SAFE DEFAULT ACTIVE STATE
    let initialValue = canopySelect.value

    if (!initialValue) {
      initialValue = canopySelect.options?.[0]?.value

      if (initialValue) {
        canopySelect.value = initialValue
      }
    }

    canopyContainer
      .querySelectorAll('.canopy-swatch')
      .forEach(el => el.classList.remove('active'))

    const selectedBtn = canopyContainer.querySelector(
      `[data-value="${initialValue}"]`
    )

    selectedBtn?.classList.add('active')
  }

  /* -----------------------------
   * GALLERY IMAGE
   * ----------------------------- */

  updateFabricGalleryImage (variant) {
    const imgs = document.querySelectorAll(
      '.swiper-main img, .product-media-gallery img'
    )

    if (!imgs.length) return

    const last = imgs[imgs.length - 1]

    const imageUrl =
      variant?.featured_image?.src ||
      variant?.image?.src ||
      null

    // If no image exists for this variant → hide last image
    if (!imageUrl) {
      last.style.display = 'none'
      return
    }

    // Otherwise ensure it's visible
    last.style.display = ''

    last.src = imageUrl
    last.srcset = imageUrl
  }

  /* -----------------------------
   * PRICING
   * ----------------------------- */

  adjustPricing (variant) {
    if (!variant) return

    const price = this.form.querySelector('.product-price-final')

    if (price) {
      price.innerHTML = window.Shopify.formatMoney(
        variant.price
      )
    }
  }

  /* -----------------------------
   * BUTTONS
   * ----------------------------- */

  adjustButtons (variant) {
    if (!variant) return

    if (variant.available) {
      this.atcBtn?.removeAttribute('disabled')
      this.buyBtn?.removeAttribute('disabled')
    } else {
      this.atcBtn?.setAttribute('disabled', 'disabled')
      this.buyBtn?.setAttribute('disabled', 'disabled')
    }
  }

  /* -----------------------------
   * UTIL
   * ----------------------------- */

  getFabricKey (value) {
    return value?.split(' - ')[0]?.trim() || ''
  }

  /* -----------------------------
   * CART
   * ----------------------------- */

  async onSubmit (e) {
    e.preventDefault()

    const formData = new FormData(this.form)

    await document
      .querySelector('cart-container')
      ?.add(formData)
  }

  onClickBuyBtn () {
    const id =
      this.form.querySelector('[name="id"]')?.value

    const qty =
      this.form.querySelector('input[name="quantity"]')
        ?.value || 1

    window.location.href = `/cart/${id}:${qty}`
  }
}

customElements.define('product-form', ProductForm)